import { render, staticRenderFns } from "./SnTabs.vue?vue&type=template&id=79021e23&scoped=true"
import script from "./SnTabs.vue?vue&type=script&lang=js"
export * from "./SnTabs.vue?vue&type=script&lang=js"
import style0 from "./SnTabs.vue?vue&type=style&index=0&id=79021e23&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79021e23",
  null
  
)

export default component.exports